import { extendTheme } from '@chakra-ui/react';

const activeLabelStyles = {
  transform: 'scale(0.85) translateY(-24px)'
};

export const chakraTheme = extendTheme({
  styles: {
    global: {
      'html, body': {
        display: 'flex',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden'
      },
      '#root': {
        display: 'flex',
        height: '100vh',
        width: '100vw',
        background: '#eaeff1',
        overflow: 'hidden'
      },
      a: {
        color: 'brand.500',
      },
      'input:-internal-autofill-selected, input:-webkit-autofill:focus': {
        transition: 'background-color 0s 600000s, color 0s 600000s',
      },
      '.leaflet-attribution-flag': {
        display: 'none !important',
      },
      'tr': {
        WebkitBorderHorizontalSpacing: '0px',
        borderImageWidth: 0,
      },
      'td': {
        WebkitBorderHorizontalSpacing: '0px',
      }
    },
  },
  colors: {
    additional: {
      500: '#63ccff',
    },
    light: {
      100: '#F4FCFF',
      200: '#E6F6FF',
      300: '#CCF0FF',
      400: '#B3E7FE',
      500: '#99E0FF',
      600: '#66D1FE',
      700: '#4DC8FF',
      800: '#32C2FE',
      900: '#1abaff',
    },
    brand: {
      100: '#66A2FF',
      200: '#4D93FE',
      300: '#3385FF',
      400: '#1975FF',
      500: '#0064FF',
      600: '#0052cc',
      700: '#003d99',
      800: '#002966',
      900: '#001433',
    },
    dark: {
      100: '#5c7ca3',
      200: '#537093',
      300: '#496383',
      400: '#405772',
      500: '#374a62',
      600: '#2e3e52',
      700: '#232f3e',
      800: '#1c2531',
      900: '#121921',
    }
  },
  components: {
    Form: {
      variants: {
        floating: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles
              }
            },
            '*, *::before, ::after': {
              borderColor: 'var(--chakra-colors-dark-100) !important'
            },
            '*:hover': {
              borderColor: 'var(--chakra-colors-brand-200) !important'
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
              ...activeLabelStyles
            },
            label: {
              top: 0,
              left: 0,
              zIndex: 2,
              position: 'absolute',
              backgroundColor: 'white',
              pointerEvents: 'none',
              mx: 3,
              px: 1,
              my: 2,
              transformOrigin: 'left top'
            }
          }
        }
      }
    }
  }
});
